import React, {Fragment} from 'react';
import {Field} from 'redux-form';
import Trash from 'react-feather/dist/icons/trash.js';

import Input from './Input.jsx';
import Select from './Select.jsx';
import conf from '../../../conf';

import './style.scss';
import './Contact.scss';

export default (props) => {
  const {fields, label, btnLabel} = props;

  return (
    <Fragment>
      <ul className="p-0">
        {fields.map((contact, index) => (
          <li key={index} className="d-flex mb-3 flex-column justify-content-center align-items-between">
            <div className="d-flex justify-content-between align-items-center">
              <h5 className="mb-0 text-capitalize">{label} #{index + 1}</h5>
              <div onClick={() => fields.remove(index)} className="d-md-none btn btn btn-outline-danger btn-round btn-sm">
                <Trash/>
              </div>
            </div>
            <div className="d-flex flex-wrap justify-content-between align-items-center">
              <div className="contact-fields-container">
                <div className="row">
                  <div className="col-lg-2">
                    <Field
                      id={`${fields.name}${index}.civility`}
                      name={`${contact}.civility`}
                      type="select"
                      component={Select}
                      label="Civilité"
                      autoComplete={`${fields.name}${index} civility`}
                    >
                      {Object.keys(conf.civilities).map((value, index) => (
                        <option value={conf.civilities[value]} key={index}>{conf.civilities[value]}</option>
                      ))}
                    </Field>
                  </div>
                  <div className="col-lg-5">
                    <Field
                      id={`${fields.name}${index}.firstname`}
                      name={`${contact}.firstname`}
                      type="text"
                      component={Input}
                      label="Prénom"
                      autoComplete={`${fields.name}${index} firstname`}
                    />
                  </div>
                  <div className="col-lg-5">
                    <Field
                      id={`${fields.name}${index}.lastname`}
                      name={`${contact}.lastname`}
                      type="text"
                      component={Input}
                      label="Nom"
                      autoComplete={`${fields.name}${index} lastname`}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <Field
                      id={`${fields.name}${index}.tel`}
                      name={`${contact}.tel`}
                      type="tel"
                      placeholder="+15142565657"
                      component={Input}
                      label="N° de téléphone"
                      autoComplete={`${fields.name}${index} tel`}
                    />
                  </div>
                  <div className="col-md-6">
                    <Field
                      id={`${fields.name}${index}.email`}
                      name={`${contact}.email`}
                      type="email"
                      component={Input}
                      label="Email"
                      autoComplete={`${fields.name}${index} email`}
                    />
                  </div>
                </div>
              </div>
              <div onClick={() => fields.remove(index)} className="d-none d-md-block btn btn-outline-danger btn-round">
                <Trash/>
              </div>
            </div>
          </li>
        ))}
      </ul>
      <p className="text-center">
        <button className="btn btn-secondary text-center" onClick={function (e) {
          e.preventDefault();
          fields.push({
            civility: conf.civilities.woman
          });
        }}>
          {btnLabel}
        </button>
      </p>
    </Fragment>
  );
};